// Titles stored on V1 migrated items and previously ILP AI generated questions
const v1QuestionTitle = {
  V1_MCQ_STANDARD: 'Multiple choice - standard',
  V1_MCQ_TRUE_OR_FALSE: 'True or false',
}
module.exports = v1QuestionTitle
